import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ADMIN_PATH } from '../config/adminRoutes';
import { CONSENT_EVENT, getConsent } from '../lib/cookieConsent';
import { postJsonReliably } from '../lib/analyticsTracking';

function PageViewTracker() {
    const { pathname } = useLocation();
    const trackedPath = useRef('');

    useEffect(() => {
        if (pathname.startsWith(ADMIN_PATH)) {
            return;
        }

        const trackCurrentPath = () => {
            if (!getConsent()?.analytics || trackedPath.current === pathname) return;
            const params = new URLSearchParams(window.location.search);
            const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid'];
            const campaign = {};
            campaignKeys.forEach((key) => {
                const value = params.get(key);
                if (value) {
                    campaign[key] = value.slice(0, 180);
                    window.sessionStorage.setItem(`esganga_${key}`, campaign[key]);
                } else {
                    campaign[key] = window.sessionStorage.getItem(`esganga_${key}`) || '';
                }
            });
            trackedPath.current = pathname;
            postJsonReliably('/api/pageviews', {
                path: pathname,
                referrer: document.referrer || '',
                utmSource: campaign.utm_source,
                utmMedium: campaign.utm_medium,
                utmCampaign: campaign.utm_campaign,
                gclid: campaign.gclid,
                analyticsAllowed: true
            });
        };

        trackCurrentPath();
        const handleConsent = (event) => {
            if (event.detail?.analytics) trackCurrentPath();
        };
        window.addEventListener(CONSENT_EVENT, handleConsent);
        return () => window.removeEventListener(CONSENT_EVENT, handleConsent);
    }, [pathname]);

    return null;
}

export default PageViewTracker;
